/**
 * 站点公共信息：企业身份、导航、页脚与联系方式。
 * 文案与联系方式来源于高保真原型，正式上线前须以客户确认资料为准。
 */

/** 一级导航子项 */
export interface NavChild {
  label: string
  to: string
}

/** 一级导航项 */
export interface NavItem {
  children?: NavChild[]
  external?: boolean
  label: string
  target?: string
  to?: string
}

/** 页脚链接 */
export type FooterLink =
  | {
      action: 'cooperation'
      label: string
    }
  | {
      external?: boolean
      label: string
      to: string
    }

/** 页脚栏目 */
export interface FooterColumn {
  links: FooterLink[]
  title: string
}

/** 企业身份 */
export const companyIdentity = {
  name: '海南兴科热带作物工程技术有限公司',
  nameEn: 'HAINAN XINGKE TROPICAL CROPS ENGINEERING TECHNOLOGY',
  intro: '以热带特色植物资源科技创新为基础，连接产品研发、中试验证、技术服务与市场化应用。',
}

/** 联系信息（电话/邮箱待客户确认） */
export const contactInfo = {
  address: '海南省万宁市兴隆热带植物园',
  phone: '待客户确认',
  email: 'hainanxingke@163.com',
}

/** 外链（正式 HTTPS 地址待确认） */
export const externalLinks = {
  botanicalGarden: 'http://www.xlrdzwy.com/',
  botanicalGardenLabel: '兴隆热带植物园',
}

/** 备案信息（链接指向工信部备案管理系统） */
export const filingInfo = {
  icp: '琼ICP备2021001585号-8',
  icpLink: 'https://beian.miit.gov.cn/',
}

/** 一级导航 */
export const siteNav: NavItem[] = [
  { label: '首页', to: '/' },
  {
    label: '企业概况',
    children: [
      { label: '企业简介', to: '/company/profile' },
      { label: '科研与产业实力', to: '/company/strength' },
      { label: '资质证书', to: '/company/qualifications' },
    ],
  },
  { label: '兴科商城', to: '/mall' },
  {
    label: '兴隆热带植物园',
    to: externalLinks.botanicalGarden,
    external: true,
    target: '_blank',
  },
]
